<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-select v-model="queryParam.batchId" @change="getPage" placeholder="选择考试" filterable style="width:200px;margin-right:10px;">
          <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.userId" placeholder="评委老师" @change="getPage({pageNum: 1})" filterable style="width: 200px;margin-right:10px;">
          <el-option v-for="item in teacherList" :key="item.userId" :label="item.username" :value="item.userId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
        <el-button @click="queryParam=JSON.parse(JSON.stringify(oldQueryParam)),getPage({pageNum: 1})" type="default">重置</el-button>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium">
        <el-table-column prop="teacherName" label="评委老师"></el-table-column>
        <el-table-column prop="evaluatedNum" label="已评分人数"></el-table-column>
        <el-table-column prop="unevaluateNum" label="未评分人数"></el-table-column>
        <el-table-column prop="passRate" label="通过率">
          <template slot-scope="scope">
            {{scope.row.passRate}}%
          </template>
        </el-table-column>
        <el-table-column prop="evaluateTime" label="更新时间">
          <template slot-scope="scope">
            <span v-if="scope.row.evaluateTime">{{$moment(scope.row.evaluateTime).format('YYYY-MM-DD HH:mm')}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="$router.push({path:'./admin-detail',query:{batchId:queryParam.batchId,teacherId:scope.row.teacherId}})">查看考生列表信息</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'admin',
  components: {},
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId },
      page: { pageSize: 20, pageNum: 1 },
      batchList: [],
      teacherList: [],
      oldQueryParam: {}
    }
  },
  async created () {
    this.batchList = await this.$HTTP.ApiBatch.getList({ batchStatus: [2] })
    if (this.Tool.isNull(this.batchList)) {
      throw new Error('没有考试数据')
    }
    if (!this.queryParam.batchId) {
      this.queryParam.batchId = this.batchList[0].batchId
    } else if (this.$route.query.batchId) {
      this.queryParam.batchId = this.$route.query.batchId
    }
    this.teacherList = await this.$HTTP.ApiUser.getTeacherList(this.queryParam)
    this.oldQueryParam = JSON.parse(JSON.stringify(this.queryParam))
    await this.getPage()
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    // async getSpecialtyList (event) {
    //   this.specialtyList = await this.$HTTP.ApiSpecialty.getList({ batchId: this.queryParam.batchId })
    //   if (event) {
    //     this.queryParam.specialtyId = ''
    //   }
    //   await this.getPage()
    // },
    async getPage (queryParam) {
      try {
        // debugger
        // this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let params = {
          batchId: this.queryParam.batchId,
          teacherId: this.queryParam.userId,
          pageNum: this.page.pageNum,
          pageSize: this.page.pageSize
        }
        let page = await this.$HTTP.ApiUser.getPageTeacher(params)
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async edit (row) {
      try {
        if (Number(row.auditStatus) === 1) {
          throw new Error('您提交的申请正在审核，请先取消申请')
        } else if (Number(row.auditStatus) === 2) {
          let confirm = await this.$confirm('您已完成审核，是否确认重新申请？', '提示', { type: 'warning' })
          if (confirm === 'confirm') {
            this.editForm.show = true
            if (row) {
              this.editForm.row = row
            } else {
              this.editForm.row = null
            }
          }
        } else {
          this.editForm.show = true
          if (row) {
            this.editForm.row = row
          } else {
            this.editForm.row = null
          }
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    }
  }
}
</script>
